import React from 'react';
import { Button } from '../components/ui/button';
import { Home, Search, ArrowRight } from 'lucide-react';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-charcoal flex items-center justify-center px-6">
      <div className="text-center max-w-2xl">
        <div className="mb-8">
          <h1 className="text-9xl font-black text-warmSage mb-4">404</h1>
          <h2 className="text-4xl font-black text-cream uppercase mb-4">Page Not Found</h2>
          <p className="text-xl text-warmGray mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        <div className="space-y-4">
          <p className="text-cream font-bold uppercase tracking-wider mb-6">
            But don't stop here. PRSVR means Keep Going.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={() => window.location.href = '/'}
              className="bg-warmSage text-charcoal hover:bg-warmSage/90 font-bold text-lg px-8 py-6"
            >
              
              Back to Home
            </Button>
            <Button 
              onClick={() => window.location.href = '/shop'}
              className="bg-cream text-charcoal hover:bg-cream/90 font-bold text-lg px-8 py-6"
            >
              <Search className="mr-2 h-5 w-5" />
              Browse Products
            </Button>
          </div>
        </div>

        <div className="mt-12 pt-12 border-t border-warmGray/20">
          <p className="text-warmGray mb-4">Popular Pages:</p>
          <div className="flex flex-wrap justify-center gap-4">
            <a href="/about" className="text-cream hover:text-warmSage transition-colors flex items-center">
              About Us <ArrowRight className="ml-1 h-4 w-4" />
            </a>
            <span className="text-warmGray">•</span>
            <a href="/uniform-order" className="text-cream hover:text-warmSage transition-colors flex items-center">
              Custom Uniforms <ArrowRight className="ml-1 h-4 w-4" />
            </a>
            <span className="text-warmGray">•</span>
            <a href="/#contact" className="text-cream hover:text-warmSage transition-colors flex items-center">
              Contact <ArrowRight className="ml-1 h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="mt-8">
          <a href="/" className="inline-block">
            <img 
              src="https://customer-assets.emergentagent.com/job_fashion-empire-2/artifacts/bcsdxd12_IMG_2797.PNG" 
              alt="PRSVR Logo" 
              className="h-16 mx-auto opacity-50 hover:opacity-100 transition-opacity"
              style={{ filter: 'brightness(0) saturate(100%) invert(98%) sepia(6%) saturate(214%) hue-rotate(327deg) brightness(102%) contrast(96%)' }}
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
